import $ from 'jquery';

const readmore = () => {
  const readmoreButton = $('.js-readmore');

  if (readmoreButton.length) {
    readmoreButton.on('keydown', e => {
      const parentLink = $(e.currentTarget).closest('a');

      if (parentLink.length && e.which === 13) {
        parentLink[0].click();
      }
    });
  }
};

export default readmore();



// WEBPACK FOOTER //
// ./src/scripts/modules/readmore.js